import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentInfoComponent } from './department-info/department-info.component';
import { DepartmentComponent } from './department/department.component';
import { DepartmentsComponent } from './departments.component';





const routes: Routes = [
 {path :"",component:DepartmentsComponent ,children:[
   {path:"Departments",component:DepartmentComponent},
   {path:"DepartmentInfo/:id",component:DepartmentInfoComponent},
   {path:"", redirectTo: 'Departments', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  
})
export class DepartmentsRoutingModule { }
